import _ from 'underscore'

import ldclient from 'lib/ldclient'

export default new class Interceptor {
  _controller = null;
  _gamma = null;

  _gammaRoutes = [
    ['/', 'gamma.route_superhome'],
    ['/shortcuts', 'gamma.route_shortcuts'],
    [/\/[a-zA-Z\d]+\/home/, 'gamma.route_superhome'] //'/:organizationName/home'
  ]

  _getFeatureKey(path) {
    const match = _.find(this._gammaRoutes, ([route, key]) => {
      return route instanceof RegExp ? route.test(path) : route === path
    })

    return match ? match[1] : null
  }

  setController(controller) {
    this._controller = controller;
  }

  setGamma(gamma) {
    this._gamma = gamma;
  }

  hideGamma() {
    $('#root').css({ display: 'none' });

    if (!this._gamma) {
      return;
    }

    this._gamma.unmount()
    this._gamma = null
  }

  navigateToGamma(path) {
    $('.header-logo').addClass('is-throbbing');
    this._controller.clearPreviousView(true)
    window.history.pushState({}, '', path);
  }

  navigateToClassic() {
    this._controller.clearPreviousView()
  }

  isGammaRoute(path) {
    return ldclient.variation(this._getFeatureKey(path), false)
  }
}


// WEBPACK FOOTER //
// ./app/scripts/singlespa/interceptor.js